export class StatusService {
    constructor() {
        this.statuses = {
            dontchange: 0,
            clean: 1,
            dirty: 2,
            working: 3,
            loading: 4,
            saving: 5,
            success: 6,
            error: 7
        };
        this.texts = this.texts1 = this.texts2 = [];
        this.classes = this.classes1 = this.classes2 = [];
        this.setDefaults();
        // handle 3 statuses on a page simutaneously
        this.statVal = [1, 1, 1];
        this.stat = ['clean', 'clean', 'clean'];
    }

    setDefaults() {
        this.texts =
            this.texts1 =
            this.texts2 =
                [
                    '',
                    'Save Changes',
                    'Save Changes',
                    'Working',
                    'Loading',
                    'Saving Changes',
                    'Saved Changes',
                    'Save Error'
                ];
        this.classes =
            this.classes1 =
            this.classes2 =
                [
                    '',
                    'btn-disabled',
                    'btn-enabled',
                    'btn-working',
                    'btn-loading',
                    'btn-processing',
                    'btn-success',
                    'btn-error'
                ];
    }

    // get the css class for first instance of status
    get class() {
        return this.classes[this.statVal[0]];
    }

    get class1() {
        return this.classes1[this.statVal[1]];
    }

    get class2() {
        return this.classes2[this.statVal[2]];
    }

    // get any css class instance (note: this method will only be one-time bound)
    getClass(instance) {
        instance = !instance ? 0 : instance;
        return this.classes[this.statVal[instance]];
    }

    // get the text for first instance of status
    get text() {
        return this.texts[this.statVal[0]];
    }

    get text1() {
        return this.texts1[this.statVal[1]];
    }

    get text2() {
        return this.texts2[this.statVal[2]];
    }

    // get the disable submit status
    get disableSubmit() {
        return this.statVal[0] != this.statuses.dirty;
    }

    get disableSubmit1() {
        return this.statVal[1] != this.statuses.dirty;
    }

    get disableSubmit2() {
        return this.statVal[2] != this.statuses.dirty;
    }

    // get any text instance (note: this method will only be one-time bound)
    getText(instance) {
        instance = !instance ? 0 : instance;
        return this.texts[this.statVal[instance]];
    }

    // internal status
    getStatus(instance) {
        instance = !instance ? 0 : instance;
        return this.stat[instance];
    }

    // change status
    dontchange(instance) {
        this.setStatus(this.statuses.dontchange, instance);
    }

    clean(instance) {
        this.setStatus(this.statuses.clean, instance);
    }

    dirty(instance) {
        this.setStatus(this.statuses.dirty, instance);
    }

    working(instance) {
        this.setStatus(this.statuses.working, instance);
    }

    loading(instance) {
        this.setStatus(this.statuses.loading, instance);
    }

    saving(instance) {
        this.setStatus(this.statuses.saving, instance);
    }

    success(instance) {
        this.setStatus(this.statuses.success, instance);
    }

    error(instance) {
        this.setStatus(this.statuses.error, instance);
    }

    // boolean statuses
    isClean(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.clean;
    }

    isDirty(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.dirty;
    }

    isLoading(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.loading;
    }

    isSaving(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.saving;
    }

    isWorking(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.working;
    }

    isSuccess(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.success;
    }

    isError(instance) {
        instance = !instance ? 0 : instance;
        return this.statVal[instance] == this.statuses.error;
    }

    // set current status, and a later status with timing
    set(statusNow, statusThen, waitTime, instance) {
        let that = this;
        instance = !instance ? 0 : instance;

        if (statusNow) {
            this.setStatus(statusNow, instance);
        }

        if (statusThen) {
            setTimeout(function () {
                that.setStatus(statusThen, instance);
            }, waitTime);
        }
    }

    setStatus(value, instance) {
        instance = !instance ? 0 : instance;
        this.statVal[instance] = value;
        this.stat[instance] = Object.keys(this.statuses)[value];
    }
}
